import { Icon } from '@iconify/react'

export const CONTENT_REFRESH_TABS = [
  {
    label: 'Domain Refresh',
    value: 'domain_refresh',
    icon: <Icon icon="lucide:globe" />,
    dataId: 'domain-refresh-switcher-button',
  },
  {
    label: 'URL Refresh',
    value: 'url_refresh',
    icon: <Icon icon="lucide:link" />,
    dataId: 'url-refresh-switcher-button',
  },
]
